import styled from 'styled-components';

import React from 'react';
import SubNavBar from './components/subNav';
import { Switch, Route, Redirect } from 'react-router';
import FadeIn from 'react-fade-in';
import { BetsTable } from './components/betsTable';
import { TotalsTable } from './components/totalsTable';
import { TotalsByBetTable } from './components/totalsByBetTable';
import { RconTable } from './components/rconTable';

const BackgroundContainer = styled.div`
  flex: 1;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 1rem;
`;

function Betting() {
  return (
    <BackgroundContainer>
      <SubNavBar />
      <Container>
        <Switch>
          <Route path="/betting/bets">
            <FadeIn>
              <BetsTable />
            </FadeIn>
          </Route>
          <Route path="/betting/totals">
            <FadeIn>
              <TotalsTable />
            </FadeIn>
          </Route>
          <Route path="/betting/totals_by_bet">
            <FadeIn>
              <TotalsByBetTable />
            </FadeIn>
          </Route>
          <Route path="/betting/rcon">
            <FadeIn>
              <RconTable />
            </FadeIn>
          </Route>
          <Route render={() => <Redirect to="/betting/bets" />} />
        </Switch>
      </Container>
    </BackgroundContainer>
  );
}

export default Betting;
